import React from 'react';

const SvgUpArrow = props => (
  <svg
    id="upArrow_svg__Layer_1"
    x={0}
    y={0}
    viewBox="-391 390.9 16.5 20.1"
    xmlSpace="preserve"
    {...props}
  >
    <style>{'.upArrow_svg__st0{fill:#3c56a6}'}</style>
    <path
      className="upArrow_svg__st0"
      d="M-374.5 399.2l-1.5 1.4-6.7-6.7-6.8 6.7-1.5-1.4 8.3-8.3z"
    />
    <path className="upArrow_svg__st0" d="M-383.8 392.4h2.1v18.7h-2.1z" />
  </svg>
);

export default SvgUpArrow;
